import React, { useEffect, useState } from 'react';
import { Container } from 'rsuite';
import { useParams } from 'react-router-dom';

import { getBriefByKey } from "../../components/briefs/briefCreationManager";
import BriefTree from './briefTree';

export default function View() {
    const { key } = useParams();
    const [briefViewData, setBriefViewData] = useState([]);

    useEffect(() => {
        getBriefByKey(key, setBriefViewData)
    }, [])

    console.log(briefViewData)

    return (
        <div className="view-main-wrapper">
            <div className='view-main'>
                <BriefTree items={briefViewData} setItems={setBriefViewData}/>
            </div>
        </div>
    );
}